"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require("../AbstractReactComponent");

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

require("./ContentPagination.scss");

var _FAIcon = require("../icon/FAIcon");

var _FAIcon2 = _interopRequireDefault(_FAIcon);

var _reactstrap = require("reactstrap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentPagination = function (_AbstractReactCompone) {
    (0, _inherits3.default)(ContentPagination, _AbstractReactCompone);

    function ContentPagination() {
        (0, _classCallCheck3.default)(this, ContentPagination);
        return (0, _possibleConstructorReturn3.default)(this, (ContentPagination.__proto__ || (0, _getPrototypeOf2.default)(ContentPagination)).apply(this, arguments));
    }

    (0, _createClass3.default)(ContentPagination, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                onPrev = _props.onPrev,
                onNext = _props.onNext,
                prev = _props.prev,
                next = _props.next,
                children = _props.children;


            return _react2.default.createElement(
                "div",
                { className: "content-pagination" },
                _react2.default.createElement(
                    "div",
                    { className: "content-pagination-left mr-2" + (prev ? "" : " disabled") },
                    _react2.default.createElement(
                        _reactstrap.Button,
                        { disabled: !prev, onClick: onPrev, color: "action" },
                        _react2.default.createElement(_FAIcon2.default, { icon: "chevron-left" })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "content-pagination-center" },
                    children
                ),
                _react2.default.createElement(
                    "div",
                    { className: "content-pagination-right ml-2" + (next ? "" : " disabled") },
                    _react2.default.createElement(
                        _reactstrap.Button,
                        { disabled: !next, onClick: onNext, color: "action" },
                        _react2.default.createElement(_FAIcon2.default, { icon: "chevron-right" })
                    )
                )
            );
        }
    }]);
    return ContentPagination;
}(_AbstractReactComponent2.default); // --


ContentPagination.propTypes = {
    prev: _react2.default.PropTypes.bool, // je aktivní tlačítko - přechozí
    next: _react2.default.PropTypes.bool, // je aktivní tlačítko - následující
    onNext: _react2.default.PropTypes.func,
    onPrev: _react2.default.PropTypes.func
};
exports.default = ContentPagination;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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